import client from '../utils/axiosInstance';

export const requestJarvisReviewAPI = async (surveyId) => {
  const response = await client.post(`agent-review/request/${surveyId}`);
  return response;
};

export const getJarvisReviewStatusAPI = async (surveyId) => {
  const response = await client.get(`agent-review/status/${surveyId}`);
  return response;
};

export const redeemJarvisReviewAPI = async (token) => {
  const response = await client.post('agent-review/redeem', { token });
  return response;
};
